import './polyfills';
import React from 'react';
// After
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import {
  setIndex,
  setDate,
  loadPairs,
  setUrlPeriod,
  setUrlCategory,
  setCategory,
  loadPerformance,
} from './actions';
import thunk from 'redux-thunk';

import reducers from './reducers';
import App from './components/App';
import Loader from './components/Loader';

let divId = 'perfattr';
let windowEnv = 'perfattr_env';

function getSyncScriptParams() {
  const scripts = document.getElementsByTagName('script');
  const lastScript = scripts[scripts.length - 1];
  const scriptName = lastScript;
  windowEnv = scriptName.getAttribute('windowEnv')
    ? scriptName.getAttribute('windowEnv')
    : 'perfattr_env';
  divId = scriptName.getAttribute('divId')
    ? scriptName.getAttribute('divId')
    : 'perfattr';
}
getSyncScriptParams();

console.log('windowEnv: ' + windowEnv);
console.log('divId: ' + divId);

const PA_ENV = window[windowEnv] || {};
const customIndex = 'WTEPS';
const customDate = '20230228';
const customPeriod = 'MTD';
const customCategory = 'ROE';

const initialState = {
  pairs: [],
  index: '',
  pair: {},
  date: '',
  data: [],
  categories: [],
  category: '',
  categoryData: {},
  period: 'MTD',
  periodData: [],
  sortDirection: '',
  sortColumn: '',
  urlDate: '',
  urlCategory: 'Sector',
  urlPeriod: 'SI',
  currentURL: '',
  wtRegion: PA_ENV.wtRegion || 'US',
  isoCode: PA_ENV.isoCode || 'en-GB',
  wtDivisionID: PA_ENV.wtDivisionID || 1,
  loading: false,
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducers,
  { performance: initialState },
  composeEnhancers(applyMiddleware(thunk))
);

//this piece will launch the variables from /example.html (i.e. for the blog)
(async () => {
  if (PA_ENV.index) {
    try {
      await store.dispatch(loadPairs());
      await store.dispatch(setDate(PA_ENV.date || customDate));
      await store.dispatch(setIndex(PA_ENV.index || customIndex));
      await store.dispatch(setUrlPeriod(PA_ENV.period || customPeriod));
      await store.dispatch(setUrlCategory(PA_ENV.category || customCategory));
      await store.dispatch(loadPerformance(false, 6));
      await store.dispatch(setCategory(PA_ENV.category || customCategory));
    } catch (error) {
      console.log(error);
    }
  }
})();

const root = createRoot(document.getElementById(divId));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App forBlog={PA_ENV.index ? true : false} />
      <Loader />
    </Provider>
  </BrowserRouter>
);
